// Tanvirul Islam's birthday - the site celebrates it for two days every year:
// the birthday itself (23 September) and a belated-wishes day (24 September).
//
// The date is judged in Bangladesh time, not the visitor's own clock, so
// someone in London and the studio in Chattogram agree on when the days
// start and end. Keep in sync with the backend's config/founderBirthday.js,
// which uses the same rule to decide when the wishes card accepts entries.
//
// To preview the celebration on any other day, open the site with
// `?birthday=preview` (the 23rd), `?birthday=belated` (the 24th, remembered
// for the tab) and `?birthday=off` to stop.
export const FOUNDER_BIRTHDAY = {
    name: "Tanvirul Islam",
    firstName: "Tanvirul",
    // One candle per letter - the name is the cake.
    candleWord: "TANVIR",
    month: 9,
    day: 23,
    // The card stays open one extra day for belated wishes.
    belatedDay: 24,
    timeZone: "Asia/Dhaka",
};

// { year, month, day } of `date` as seen in the birthday's time zone.
export const getBirthdayZoneDate = (date = new Date()) => {
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: FOUNDER_BIRTHDAY.timeZone,
        year: "numeric",
        month: "numeric",
        day: "numeric",
    }).formatToParts(date);
    const get = (type) => Number(parts.find((p) => p.type === type).value);
    return { year: get("year"), month: get("month"), day: get("day") };
};

export const isFounderBirthday = (date = new Date()) => {
    const { month, day } = getBirthdayZoneDate(date);
    return month === FOUNDER_BIRTHDAY.month && day === FOUNDER_BIRTHDAY.day;
};

// The day after - the card stays open for belated wishes.
export const isBelatedBirthday = (date = new Date()) => {
    const { month, day } = getBirthdayZoneDate(date);
    return month === FOUNDER_BIRTHDAY.month && day === FOUNDER_BIRTHDAY.belatedDay;
};

// Either celebration day. The section, pill and card all key off this.
export const isBirthdaySeason = (date = new Date()) => isFounderBirthday(date) || isBelatedBirthday(date);

// 'birthday' on the 23rd, 'belated' on the 24th, null otherwise.
export const getBirthdayMode = (date = new Date()) => {
    if (isBelatedBirthday(date)) return "belated";
    if (isFounderBirthday(date)) return "birthday";
    return null;
};
